import './styles/main.css'
import './styles/loader-styles.css'
import './styles/print.css'
import 'cesium/Build/Cesium/Widgets/widgets.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Ion, RuntimeError } from 'cesium'
import awsconfig from './aws-exports'
import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { sessionStorage } from 'aws-amplify/utils'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import log from './utils/useLogger'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { initSentry } from './observability/sentry'
import { vTrack } from './directives/vTrack'
import { vTooltip } from './directives/vTooltip'
import { vClickOutside } from '@/directives/vClickOutside'

import App from './App.vue'
import router from './router'

document.addEventListener('click', function (e) {
  if (!e.target) return

  const pickerInput = (e.target as HTMLElement).closest('.picker_input')

  if (pickerInput) {
    const pickerOptions = pickerInput.nextElementSibling

    if (pickerOptions && (pickerOptions as HTMLElement).style.display === 'flex') {
      ;(pickerOptions as HTMLElement).style.display = 'none'
    } else {
      document.querySelectorAll('.picker_options').forEach((option) => {
        ;(option as HTMLElement).style.display = 'none'
      })

      if (pickerOptions) {
        ;(pickerOptions as HTMLElement).style.display = 'flex'
      }
    }
  } else {
    document.querySelectorAll('.picker_options').forEach((option) => {
      ;(option as HTMLElement).style.display = 'none'
    })
  }
  const plate = (e.target as HTMLElement).closest('.icon-plate')
  if (plate) {
    const plateSection = plate.nextElementSibling as HTMLElement | null
    if (plateSection && plateSection.style.display === 'block') {
      plateSection.style.display = 'none'
    } else {
      document.querySelectorAll<HTMLElement>('.plate-section').forEach((option) => {
        option.style.display = 'none'
      })

      if (plateSection) {
        plateSection.style.display = 'block'
      }
    }
  }
})

// Set up Cesium Ion with error handling
try {
  Ion.defaultAccessToken = import.meta.env.VITE_APP_CESIUM_TOKEN
} catch (error) {
  if (error instanceof RuntimeError) {
    log.error(`Cesium Ion RuntimeError: ${error.message}`)
    log.error(`Stack trace: ${error.stack}`)
  } else {
    log.error('Error initializing Cesium Ion:', error)
  }
  // Use a default token or alternate strategy
}

const app = createApp(App)

// Initialize Sentry as early as possible
initSentry(app, router)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
Amplify.configure(awsconfig)

// Configure Amplify Auth to use sessionStorage
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage)
app.use(pinia)
app.use(router)
app.use(VueTelInput)
app.component('VueDatePicker', VueDatePicker)
app.use(VueQueryPlugin)
app.directive('track', vTrack)
app.directive('tooltip', vTooltip)
app.directive('click-outside', vClickOutside)
if (pinia) {
  ;(window as any).pinia = pinia
}
app.mount('#app')
